// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"917f0bc4","480":"b3d5f15d"}[chunkId] + ".chunk.css";
};